export enum Perfil {
  QUEBRADEIRA = 'quebradeira',
  FAMILIAR = 'familiar',
  ENTREPOSTO = 'entreposto',
  PARCEIRO = 'parceiro',
  DIRECAO = 'direcao',
  ASSESSORIA = 'assessoria',
  SUPERADMIN = 'superadmin',
}

export function getPerfilLabel({ perfil }: { perfil: Perfil }): string {
  switch (perfil) {
    case Perfil.QUEBRADEIRA:
      return 'Quebradeira';
    case Perfil.FAMILIAR:
      return 'Familiar';
    case Perfil.ENTREPOSTO:
      return 'Entreposto';
    case Perfil.PARCEIRO:
      return 'Parceiro';
    case Perfil.DIRECAO:
      return 'Direção';
    case Perfil.ASSESSORIA:
      return 'Assessoria';
    case Perfil.SUPERADMIN:
      return 'Super Admin';
  }
}
